"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MODAL_SIZES = void 0;
var MODAL_SIZES = Object.freeze({
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
  FULL_SCREEN: 'fullScreen'
});
exports.MODAL_SIZES = MODAL_SIZES;